'use strict';
const angular = require('angular');

/*@ngInject*/
export function ProjectService($resource) {
  return $resource('/api/projects/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/projects/:id/attachments"
    }
  });
}


export default angular.module('conduu.ProjectService', [])
  .factory('ProjectService', ProjectService)
  .name;



// WEBPACK FOOTER //
// ./client/components/project/project.service.js